import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Login } from '../components/Login';

export const Landing: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative flex flex-col bg-cream">
      {/* Hex Pattern Background */}
      <svg className="fixed inset-0 w-full h-full opacity-5 z-0" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="hex-landing" width="56" height="100" patternUnits="userSpaceOnUse" patternTransform="scale(1.5)">
            <path d="M28 66L0 50L0 16L28 0L56 16L56 50L28 66Z" fill="none" stroke="#af3216" strokeWidth="1"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#hex-landing)"/>
      </svg>

      {/* Header Ondako */}
      <header className="bg-white/80 backdrop-blur-sm shadow-ambient relative z-10">
        <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2">
            <span className="font-logo font-bold text-coral text-2xl">Ondako</span>
          </a>
          <div className="flex items-center gap-4">
            <a
              href="https://ondako.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 text-white font-semibold rounded-full transition-all hover:-translate-y-0.5 bg-coral hover:bg-coral-dim"
            >
              Accueil Ondako
            </a>
            <a
              href="https://cours.ondako.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 font-semibold rounded-full transition-all hover:-translate-y-0.5 border border-coral/30 text-coral hover:bg-coral/5"
            >
              Cours en ligne
            </a>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <div className="relative z-10 flex-grow flex items-center justify-center py-16">
        <div className="w-full max-w-md mx-auto px-4">
          {/* Titre au-dessus du bloc de connexion */}
          <h1 className="text-center mb-8">
            <span className="text-3xl md:text-4xl font-bold text-ink">
              Accédez à votre
            </span>
            <br />
            <span className="text-3xl md:text-4xl font-bold text-coral">
              Tableau de bord
            </span>
          </h1>

          {/* Bloc de connexion */}
          <section id="connexion" className="bg-white shadow-ambient-lg rounded-2xl p-8">
            <Login onLoginSuccess={() => navigate('/dashboard')} />
          </section>
        </div>
      </div>

      {/* Footer minimaliste */}
      <footer className="bg-cream border-t border-cream-high relative z-10 py-4">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-ink-soft text-sm">&copy; 2026 Ondako. Tous droits reserves.</p>
        </div>
      </footer>
    </div>
  );
};
